export default {
    /*  需要添加
    mounted() {
            this.qywxHandler();
    },
     */
    methods: {
        qywxHandler() {
            const vm = this;
            const is_wx_state = this.$route.query.state && this.$route.query.state.substring(0,2) === 'wx';
            if (this.$organization.use_wechat && this.$route.query.code && is_wx_state) {// read user info
                this.$api('Wechat.QYWeb', {code: this.$route.query.code, state: this.$route.query.state}).then(res => {
                    if (res.data.success) {
                        vm.setUserInfo(res.data.data);

                        let redirect = this.redirectPath();
                        if (!redirect) redirect = "/";
                        vm.$router.replace(redirect);

                    } else {
                        let msg = '错误的企业微信返回信息,请用其他方式登录!';
                        if (res.data.text && res.data.text != 'INVALID') msg = res.data.text;
                        vm.$messageBox.error(msg);
                        let redirect = this.redirectPath();
                        redirect = !redirect ? "/sign-in" : ("/sign-in?_t=" + redirect);
                        vm.$router.replace(redirect);
                        vm.ready = true;
                    }
                });
            } else if (this.$isWechat() && this.$organization.use_wechat) { // 微信客户端
                // 构建微信跳转地址
                // https://open.weixin.qq.com/connect/oauth2/authorize?appid=appid&redirect_uri=%2F&response_type=code&scope=snsapi_userinfo&agentid=1000013&state=STATE#wechat_redirect
                let state = 'wx';
                if (this.$route.query._t) {
                    state = 'wx_' + encodeURIComponent(this.$route.query._t);
                }
                const wx_redirect = "https://open.weixin.qq.com/connect/oauth2/authorize?" +
                    "appid=" + this.$organization.wechat_appid +
                    "&redirect_uri=" + encodeURIComponent(this.$organization.signin_url) +
                    "&response_type=code&scope=snsapi_userinfo&agentid=" + this.$organization.wechat_agentid +
                    "&state=" + state + "#wechat_redirect";
                window.location.href = wx_redirect;
            } else {
                this.ready = true;
            }
        },
        redirectPath(){
            let redirect = null;
            if (this.$route.query.state.substring(0,3) === 'wx_') {
                redirect =  decodeURIComponent(this.$route.query.state.substring(3));
            }
            return redirect;
        }
    }
}
